export class CosmeticControls {
  constructor(init?: Partial<CosmeticControls>) {
    if (init) Object.assign(this, init);
  }

  labelOptionsOpen = false;
  highlightOptionsOpen = false;
  soundOptionsOpen = false;

  hasChangedLabel = false;
  hasChangedIcon = false;
  hasChangedBeam = false;
  hasChangedSound = false;
}
